var $3c567f46aec1205a$exports = {};
$3c567f46aec1205a$exports = {
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`
};


export {$3c567f46aec1205a$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
